// extracted by mini-css-extract-plugin
export default {"Container":"QuestionMapping_Container__+3TQc","QuestionLabelContainer":"QuestionMapping_QuestionLabelContainer__283Xk","QuestionLabel":"QuestionMapping_QuestionLabel__FwILF"};